export class DeprecatedClearWillError extends Error {
  message: string;
  redirectTo: string;
  constructor(message: string, redirectTo: string) {
    super();

    this.message = message;
    this.redirectTo = redirectTo;
  }
}
